import { motion, useReducedMotion } from 'framer-motion'

const EASE = [0.16, 1, 0.3, 1]

/**
 * Artwork behind the "My Cards" header: one case in the dark, to the right of the title, resting
 * just on top of the overview strip (the strip hides its reflection, so it reads as a shelf).
 *
 * Desktop only. On narrower screens the title and the strip already fill the width, and a picture
 * behind the text would hurt more than it helps.
 *
 * Must be placed inside a positioned, overflow-hidden parent (see `Section`'s `backdrop`).
 */
export default function OwnerBackdrop() {
  const reduceMotion = useReducedMotion()

  return (
    <div
      className="pointer-events-none absolute inset-x-0 top-0 z-0 hidden h-[460px] lg:block"
      aria-hidden="true"
    >
      <div className="relative mx-auto h-full max-w-[1200px]">
        <div className="absolute -right-[6%] top-0 h-full w-[818px]">
          <motion.img
            src="/home/owner-case.jpg"
            width="1024"
            height="576"
            alt=""
            decoding="async"
            draggable="false"
            className="absolute inset-0 block h-full w-full select-none object-cover"
            {...(reduceMotion
              ? {}
              : {
                  initial: { opacity: 0, scale: 1.06 },
                  animate: { opacity: 1, scale: 1 },
                  transition: { duration: 1.8, ease: EASE },
                })}
          />
          <div className="m1nt-grain absolute inset-0" />
          {/* Melt every edge into the page colour. */}
          <div
            className="absolute inset-0"
            style={{
              background:
                'linear-gradient(to right, #0A090D 0%, rgba(10,9,13,0.8) 14%, rgba(10,9,13,0) 42%, rgba(10,9,13,0) 78%, #0A090D 100%), linear-gradient(to bottom, #0A090D 0%, rgba(10,9,13,0) 16%), linear-gradient(to top, #0A090D 0%, rgba(10,9,13,0) 14%)',
            }}
          />
        </div>
      </div>
    </div>
  )
}
